import './page-loading.css';

import { LoadingSpinner } from '@kerfjs/ui/loading-spinner';
import type { SafeHtml } from 'kerfjs';

/** Center a full-page loading state inside the available pane content. */
export function PageLoading({ label }: { label: string }): SafeHtml {
  return (
    <div class="page-loading">
      <LoadingSpinner label={label} size="xl" />
    </div>
  );
}
